import { render } from "./TvmFlowNameIndicator.vue?vue&type=template&id=21681d75&scoped=true"
import script from "./TvmFlowNameIndicator.vue?vue&type=script&lang=js"
export * from "./TvmFlowNameIndicator.vue?vue&type=script&lang=js"

import "./TvmFlowNameIndicator.vue?vue&type=style&index=0&id=21681d75&lang=less&scoped=true"

import exportComponent from "../../../../../vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21681d75"],['__file',"js/components/shared/ChatWidget/TvmFlowNameIndicator/TvmFlowNameIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21681d75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21681d75', __exports__)) {
    api.reload('21681d75', __exports__)
  }
  
  module.hot.accept("./TvmFlowNameIndicator.vue?vue&type=template&id=21681d75&scoped=true", () => {
    api.rerender('21681d75', render)
  })

}


export default __exports__